// extracted by mini-css-extract-plugin
export default {"options":"panelTrigger_options__wilj1","optionOne":"panelTrigger_optionOne__O1lx0","optionTwo":"panelTrigger_optionTwo__GdQ6I"};